<template>
  <v-dialog class='edit-profile-popup' :value="visiblePopup" persistent overlay-color='blue' fullscreen @keydown.esc="onCloseEditProfilePopup">
    <div class='edit-sp-employee-profile-layout'>
      <EditSPEmployeeProfileHeader
        class='edit-sp-header'
        @onCloseEditProfilePopup='onCloseEditProfilePopup'
        @onOpenPreviewClicked='onOpenPreviewClicked'
        @onDeleteEmployeeClicked='onDeleteEmployeeClicked'
        @onResetActiveClicked='onResetActiveClicked'
      ></EditSPEmployeeProfileHeader>
      <EditSPEmployeeProfileBody
        v-if='workerProfile'
        @formChanged = 'formChanged'
        @saveEditedUser='saveEditedUser'
        class='edit-sp-body'
      />
      <yes-no-popup
        :title="$t('note.title')"
        :visible-popup='showNotePopup'
        :message="$t('pending.changes.alert')"
        :no-caption="$t('no.caption.unsaved.changes.popup')"
        :yes-caption="$t('yes.caption.unsaved.changes.popup')"
        @clicked='onClickYesNoButton'
      />
      <worker-details-popup
        :visible-popup="showWorkerDetailsPopup"
        :worker="spEmployeeBeforeEdit"
        @closed="toggleWorkerDetailsPopup"
      />
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import EditSPEmployeeProfileHeader from '@/components/EditSPEmployeeProfile/EditSPEmployeeProfileHeader.vue';
import EditSPEmployeeProfileBody from '@/components/EditSPEmployeeProfile/EditSPEmployeeProfileBody.vue';
import {
  CHANGE_SERVICE_PROVIDER_EMPLOYEE_ACTIVE_STATUS,
  DELETE_SERVICE_PROVIDER_EMPLOYEE_USER,
  LOAD_CURRENT_SERVICE_PROVIDER_EMPLOYEE, UPDATE_SERVICE_PROVIDER_WORKER_PROFILE_BY_ADMIN,
} from '@/store/user/actionTypes';
import WorkerDetailsPopup from '@/components/popup/WorkerDetailsPopup.vue';
import YesNoPopup from '@/components/popup/YesNoPopup.vue';

export default {
  name: 'EditSPEmployeeProfileLayout',
  components: {
    YesNoPopup, EditSPEmployeeProfileHeader, EditSPEmployeeProfileBody, WorkerDetailsPopup,
  },
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    async chosenSPEmployeeId() {
      await this.$store.dispatch(LOAD_CURRENT_SERVICE_PROVIDER_EMPLOYEE, this.chosenSPEmployeeId);
    },
  },
  computed: {
    ...mapGetters(['currentSPEmployee', 'chosenSPEmployeeId', 'profile', 'spEmployeeBeforeEdit']),
    workerProfile() {
      return this.currentSPEmployee.workerProfile;
    },
  },
  data() {
    return {
      showWorkerDetailsPopup: false,
      formChangedFlag: false,
      showNotePopup: false,
    };
  },
  methods: {
    onCloseEditProfilePopup() {
      this.formChangedFlag = false;
      this.$emit('onCloseEditProfilePopup', true);
    },
    async onClickYesNoButton(result) {
      this.showNotePopup = false;
      if (result) {
        this.showWorkerDetailsPopup = true;
      }
    },
    formChanged() {
      this.formChangedFlag = true;
    },
    async toggleWorkerDetailsPopup() {
      this.showWorkerDetailsPopup = !this.showWorkerDetailsPopup;
    },
    async onOpenPreviewClicked() {
      if (this.formChangedFlag) {
        this.showNotePopup = true;
      } else {
        await this.toggleWorkerDetailsPopup();
      }
    },
    async saveEditedUser() {
      await this.$store.dispatch(UPDATE_SERVICE_PROVIDER_WORKER_PROFILE_BY_ADMIN, this.currentSPEmployee);
      this.$emit('onCloseEditProfilePopup', true);
    },
    async onResetActiveClicked() {
      await this.$store.dispatch(CHANGE_SERVICE_PROVIDER_EMPLOYEE_ACTIVE_STATUS, this.chosenSPEmployeeId);
      await this.$store.dispatch(LOAD_CURRENT_SERVICE_PROVIDER_EMPLOYEE, this.chosenSPEmployeeId);
    },
    async onDeleteEmployeeClicked() {
      await this.$store.dispatch(DELETE_SERVICE_PROVIDER_EMPLOYEE_USER, this.chosenSPEmployeeId);
      this.$emit('onCloseEditProfilePopup', true);
    },
  },
};
</script>
<style lang='scss'>
@import '~@/assets/styles/design-system';

.v-dialog {
  background-color: var(--bg-primary);
}
</style>
<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.edit-profile-popup {
  justify-content: center;
  align-content: center;
}
.edit-sp-employee-profile-layout {
  height: fit-content;
  margin-top: 3%;
  margin-bottom: 1%;
  display: flex;
  flex-direction: column;
  width: rem(892);
  justify-content: center;
  margin-left: 25%;
  align-content: center;
  background-color: var(--bg-primary);
  .edit-sp-header {
    flex: rem(56);
  }
  .edit-sp-body {
    flex: 1;
  }
}
</style>
